import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DomainAttributeModel, StatusReferenceModel } from 'src/app/core/models/reference-model/reference-general-model';
import { SecurityGroupSecurityModel } from 'src/app/core/models/security-model/security-group-security.model';
import { OrganisationAttributePanelComponent } from './organisation-attribute-panel/organisation-attribute-panel.component';

@Component({
    selector: 'op-organisation-attribute',
    templateUrl: './organisation-attribute.component.html'
})
export class OrganisationAttributeComponent {
    @Input() focused: boolean = false;
    @Input() newOrganisation: boolean = false;
    @Input() panelTitle = 'ORGANISATION ATTRIBUTES';
    @Input() selectedOrganisationType: string[];
    @Input() isFilterPanel: boolean = false;
    @Input() organisationAttribute$ = new BehaviorSubject<DomainAttributeModel[]>(null);
    @Input() userSecurity: SecurityGroupSecurityModel;
    @Input() existOwnerType: boolean = false;
    @Input() organisationId: string;
    @Input() statusReferences$: BehaviorSubject<StatusReferenceModel[]>;

    @Output() onSearch = new EventEmitter();

    @ViewChild('organisationAttribute') attributeComponent: OrganisationAttributePanelComponent;
    @ViewChild('organisationValidation') validationComponent: OrganisationAttributePanelComponent;

    public organisationTypeCodes: string[];

    constructor(private changeDetectionRef: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.changeDetectionRef.detectChanges();
    }

    clearAdvanceCondition() {
        this.attributeComponent.organisationAttributes = null
        this.attributeComponent.clearActionForm();
    }

    checkPendingData(): boolean {
        if (this.attributeComponent.edited == true) {
            return true;
        }
        return false;
    }

    clearPendingData() {
        this.attributeComponent.edited = false;
    }

    getErrorMessage() {
        if (!this.validateAttribute()) {
            return this.attributeComponent.getAttributeErrorMessage();
        }
    }

    search() {
        this.onSearch.emit();
    }

    validateAttribute(): boolean{
        return this.attributeComponent.validateRequired();
    }


}
